import { createReducer, createNamespacer } from '../commons/js/utils/reducer';

const namespacers = {
    pagination: createNamespacer("PAGINATION"),
}

const initialstate = {
    currentPage: 1,
}

const paginationReducer = createReducer(initialstate, {
    [namespacers.pagination("SET_CURRENT_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value
        }
    },
})

export default paginationReducer;
